const order = 11;
const routes = {
  path: "/user-work",
  name: "UserWork",
  component: () => import("@/views/layout"),
  meta: {
    title: "教师工作（仅开发）",
    hidden: true,
    guard: {
      permission: ["upms:userWork"],
    },
  },
  children: [
    {
      path: "affair",
      name: "UserWorkAffairs",
      meta: {
        title: "事务",
        icon: "ri-calendar-todo-line",
        guard: {
          permission: ["upms:userWork:affairs"],
        },
      },
      children: [
        {
          path: "teacherAffairs",
          name: "TeacherAffairs",
          meta: {
            title: "教师事务",
            guard: {
              permission: ["upms:userWork:affairs:teacherAffairs"],
            },
          },
          children: [
            {
              path: "initiate",
              name: "UserAffairsInitiate",
              component: () => import("@/views/process/initiate/initiate"),
              meta: {
                title: "发起流程",
                guard: {
                  permission: ["upms:userWork:affairs:teacherAffairs:initiate"],
                },
              },
            },
            {
              path: "initiated",
              name: "UserAffairsInitiated",
              component: () => import("@/views/process/initiate"),
              meta: {
                title: "我的申请",
                guard: {
                  permission: [
                    "upms:userWork:affairs:teacherAffairs:initiated",
                  ],
                },
              },
            },
          ],
        },
      ],
    },
  ],
};
const perms = {
  UserAffairsInitiated: [
    {
      title: "修改",
      permission: "upms:userWork:affairs:teacherAffairs:initiated:edit",
    },
    {
      title: "撤回",
      permission: "upms:userWork:affairs:teacherAffairs:initiated:withdraw",
    },
    {
      title: "删除",
      permission: "upms:userWork:affairs:teacherAffairs:initiated:del",
    },
  ],
};

export { order, routes, perms };
